/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var infiniteHits = algolia.externals.widgets.infiniteHits;
  var configure = algolia.externals.widgets.configure;
  var queryRuleCustomData = algolia.externals.widgets.queryRuleCustomData;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;

  var collectionPage =
    Boolean(algolia.is_collection_results_page) &&
    Boolean(algolia.config.instant_search_enabled_on_collection);

  var isMobile = (window.screen.availWidth > 640) ? false : true;
    
  if (
    (!algolia.full_results && !collectionPage) ||
    !algolia.config.instant_search_enabled
  ) {
    return;
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  if (collectionPage) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    var handle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + handle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : handle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPage
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPage && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  function singleIndex(indexName) {
    return {
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return route;
      },
      routeToState: function(routeState) {
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  let previousSearchTerm;

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPage && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPage && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPage && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPage && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
    isMobile
      ? 8 // mobile results count
      : collectionPage && algolia.config.collections_full_results_hits_per_page
      ? algolia.config.collections_full_results_hits_per_page
      : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: debounce(function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPage) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      }),
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        'instant_search_current_refined_values_item'
      ),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  if (instant.poweredBy) {
    // eslint-disable-next-line no-console
    // console.log('Algolia: Instant-Search');
  }

  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  if (
    collectionPage &&
    document.querySelectorAll(algolia.config.collection_css_selector).length ===
      0
  ) {
    throw new Error(
      'Instant search CSS selector for collection page is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  // // Mobile facets display
  // instant.search.addWidgets([
  //   {
  //     init: function() {
  //       var $button = document.querySelector('.ais-facets-button');
  //       $button.addEventListener('click', function() {
  //         var $facets = document.querySelector('.ais-facets');
  //         $('.ais-facets-button .toggler-mode').toggle();

  //         if ($facets.classList.contains('ais-facets__shown')) {
  //           //$button.textContent = 'Show filters';
  //           $facets.classList.remove('ais-facets__shown');
  //         } else {
  //           //$button.textContent = 'Hide filters';
  //           $facets.classList.add('ais-facets__shown');
  //         }
  //       });
  //     },
  //   },
  // ]);

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: true,
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '#ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
      showLoadingIndicator: false,
      clearsQuery: true,
    }),
  ]);

  // Custom Rule Query Data
  instant.search.addWidgets([
    queryRuleCustomData({
      container: '#queryRuleCustomData',
      transformItems(items) {
        const match = items.find(data => Boolean(data.redirect));
        if (match && match.redirect) {
          window.location.href = match.redirect;
        }
        return ;
      },
    }),
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        if (!instant.poweredBy) {
          document.querySelector('.ais-algolia-icon').style.display = 'none';
        }
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            document.querySelector('.ais-algolia-icon').style.display = '';
          }
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
          document.querySelector('.ais-algolia-icon').style.display = 'none';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        document
          .querySelector('.ais-search-header .ais-change-display-block')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-block:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-list.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-list')
              .classList.replace('ais-results-as-list', 'ais-results-as-block');
          });
        document
          .querySelector('.ais-search-header .ais-change-display-list')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-list:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-block.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-block')
              .classList.replace('ais-results-as-block', 'ais-results-as-list');
          });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttribtues = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"'; // Algolia patch for potential XSS issue
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttribtues(refinement) +
          '    class="ais-current-refined-values--link" aria-label="AIS refined values link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          facet.title +
          '      </div>: ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]); // Algolia patch for potential XSS issue
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  // Facets
  instant.facets.widgets.forEach(function(widget) {
    instant.search.addWidgets([widget.widget(widget.params)]);
  });

  const sessionStorageCache = instantsearch.createInfiniteHitsSessionStorageCache();

  // Hits
  instant.search.addWidgets([
    infiniteHits({
      container: '.ais-InfiniteHits-container',
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
        showMoreText() {
          return `<span>Load More Products</span>`
        },
      },
      transformItems: function(products) {
        return products.map(function(product) {
          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            can_order:
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
          });
        });
      },
      cache: sessionStorageCache,
    }),
  ]);

  // Add color swatches to hits
  const searchClient = algoliasearch(algolia.config.app_id, algolia.config.search_api_key);
  const index = searchClient.initIndex(instant.search.indexName);
  let timerId;

  instant.search.addWidgets([
    {
      render(renderOptions) {
        const productIds = renderOptions.results.hits
          .filter((hit) => hit.variants_count > 0)
          .map((hit) => `id:${hit.id}`);

        if (productIds.length < 1) return; // exit if no products

        let searchFilters = renderOptions.state.filters ? `${renderOptions.state.filters} AND ${productIds.join(' OR ')}` : productIds.join(' OR ');

        clearTimeout(timerId);
        timerId = setTimeout(
          () =>
            index
              .search(renderOptions.state.query, {
                filters: searchFilters,
                attributesToRetrieve: ['title','id','objectId','option1', 'options', 'image', 'price', 'compare_at_price', 'tags'],
                attributesToHighlight: false,
                attributesToSnippet: false,
                hitsPerPage: 1000,
                distinct: false,
              })
              .then(({ hits }) => {
                const productVariantsMap = new Map();
                hits.forEach((hit) => {
                  if (productVariantsMap.has(hit.id)) {
                    productVariantsMap.set(hit.id, [
                      ...productVariantsMap.get(hit.id),
                      hit,
                    ]);
                  } else {
                    productVariantsMap.set(hit.id, [hit]);
                  }
                });

                for (const [key, value] of productVariantsMap.entries()) {


                  if (value[0] && value[0].tags.includes('Rental')) {
                  
                    const pricingContainer = document.querySelector(`#product-pricing-${key}`);
                    if(pricingContainer) pricingContainer.innerHTML = "";
                    pricingContainer.classList.add("flex", "flex-wrap", "gap-x-4", "gap-y-2", "w-full");
                    const swatchContainer = document.querySelector(`#product-swatches-${key}`);
                    swatchContainer.innerHTML = swatchContainer && value[0].tags.includes('Snow') ? `<div class="text-sb-green font-barlow font-semibold col-start-2 col-end-11 leading-[1.125] text-center">${rentalsSnowMessage}</div>` : "";
                    value.sort((a, b) => a.price - b.price);
                    value.forEach(variant => {
                      const variantTitle = variant.option1.split(" — ")[0];
                      const htmlOutput = `<div id="rental-variant__${key}" class="rental-variant flex justify-between basis-full md:basis-[calc(50%-0.5rem)] border-b-2"><div class="rental-variant__title">${variantTitle}</div><div class="rental-variant__price font-bold">$${variant.price}</div></div>`;
                      if(pricingContainer) pricingContainer.innerHTML += htmlOutput;
                    })

                  } else {
                    // get max savings and compare at price
                    let savingsArray = [];
                    let compareAtPrice = 0;
                    value.forEach(item => {
                      let s = item.tags.includes('hidediscount') ? Math.round((1 - (item.price / item.compare_at_price)) * 100) : Math.round((1 - ((item.price * 0.9) / item.compare_at_price)) * 100);
                      savingsArray.push(s);
                      compareAtPrice = item.compare_at_price > compareAtPrice ? item.compare_at_price : compareAtPrice;
                    });
                    let maxSavings = Math.max(...savingsArray);

                    // get unique images
                    const swatchContainer = document.querySelector(`#product-swatches-${key}`);
                    const uniqueImages = new Set();
                    let uniqueColorVariants = value.filter(item => {
                        if (!uniqueImages.has(item.image)) {
                            uniqueImages.add(item.image);
                            return true;
                        }
                        return false;
                    });
                    uniqueColorVariants.forEach((v,i) => {
                      let swatch = i === 0 ?
                      `<img src="${v.image.replace(".jpg", "_50x50.jpg").replace(".png", "_50x50.png")}" data-full="${v.image.replace(".jpg", "_404x404.jpg").replace(".png", "_404x404.png")}" data-variant="${v.objectID}" data-option1="${v.option1}" data-parent="${key}" width="50" height="50" loading="lazy" class="active" />`:
                      `<img src="${v.image.replace(".jpg", "_50x50.jpg").replace(".png", "_50x50.png")}" data-full="${v.image.replace(".jpg", "_404x404.jpg").replace(".png", "_404x404.png")}" data-variant="${v.objectID}" data-option1="${v.option1}" data-parent="${key}" width="50" height="50" loading="lazy" />`;
                      if(swatchContainer) swatchContainer.innerHTML += swatch;
                    });

                    // get unique prices
                    const uniquePricesSet = new Set();
                    let uniquePriceVariants = value.filter(item => {
                        if (!uniquePricesSet.has(item.price)) {
                          uniquePricesSet.add(item.price);
                            return true;
                        }
                        return false;
                    });
                    let uniquePrices = Array.from(uniquePricesSet);
                    uniquePrices.sort(function(a, b) { return a - b; });
                    
                    const flagsContainer = document.querySelector(`#product-card--${key} .product-flags`);
                    const pricingContainer = document.querySelector(`#product-card--${key} .product-card--pricing`);

                    let pricingContent = value[0].tags.includes('NPISO') 
                      ? `<div class="font-bold italic">In-store Only</div>`
                      : uniquePrices.length > 1 
                      ? `<div class="font-bold">$${uniquePrices[0].toFixed(2).replace(/\.00$/, '')} - $${uniquePrices[uniquePrices.length - 1].toFixed(2).replace(/\.00$/, '')}</div>`
                      : maxSavings > 10 
                      ? `
                        <div>
                          <span class="font-bold text-sb-orange">$${uniquePrices[0].toFixed(2).replace(/\.00$/, '')}</span>
                          <span class="text-sb-grey-600 line-through ml-1">$${compareAtPrice.toFixed(2).replace(/\.00$/, '')}</span>
                        </div>
                      `
                      :
                      `
                        <div class="font-bold">$${uniquePrices[0].toFixed(2).replace(/\.00$/, '')}</div>
                      `
                      ;

                    if(maxSavings > 10) {
                      const savingsFlag = document.createElement("div");
                      savingsFlag.classList.add("product-flag", "h6", "savings");
                      flagsContainer.appendChild(savingsFlag);
                      pricingContent += `<div class="text-sb-orange text-sm">Up to ${maxSavings}% off</div>`;
                    }
                    pricingContainer.innerHTML = pricingContent;

                  }
                }
              }),
          300
        );
      },
    },
  ]);  

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-InfiniteHits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          var link = '/products/' + productHandle;
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
          if (algolia.config.analytics_enabled) {
            var clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-InfiniteHits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-InfiniteHits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Main
  instant.search.start();

  // hide empty facets
  instant.search.on('render', function () {
    var facetSelector = '.ais-RefinementList';
    var facets = document.querySelectorAll(facetSelector);
    var emptyFacetSelector = '.ais-RefinementList--noRefinement';
    var emptyFacets = document.querySelectorAll(emptyFacetSelector);
    facets.forEach(function (elem) {
      elem.parentNode.parentNode.style.display = 'block';
    });
    emptyFacets.forEach(function (elem) {
      elem.parentNode.parentNode.style.display = 'none';
    });
    //Initialize swym Collections
    document.dispatchEvent(new Event("swym:collections-init"))
  });

  // clear refinement on new search
  $('.ais-SearchBox-input').on('input', function() {
    var userInput = $('.ais-SearchBox-input').val();
    if(Boolean(!algolia.is_collection_results_page)) {
      $('.ais-ClearRefinements-button').click();
    }
  });

  // jump to top on search change
  $('.ais-SearchBox-input').on('input', debounce(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }));

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);